import React from "react";
import { Link } from "react-router-dom";
import Container from "../../components/Container";
import logo from "../../assets/images/logo.png";
import { IoArrowForwardOutline } from "react-icons/io5";
import LoginForm from "../../components/LoginForm";
import RegisterForm from "../../components/RegisterForm";

const Register = () => {
  return (
    <section>
      <Container maxWidth={"max-w-5xl"}>
        <div className="header my-6">
          <div className="flex justify-between items-center">
            <div className="logo w-28">
              <Link to={"/everyone"}>
                <img src={logo} alt="" />
              </Link>
            </div>
            <div className="sign-in">
              <Link to={"/log-in"} className="flex items-center gap-3 p-3">
                <span>Login</span>
                <span>
                  <IoArrowForwardOutline />
                </span>
              </Link>
            </div>
          </div>
        </div>
        <div className="flex bg-white xs:p-6 sm:p-10 border rounded-lg">
          <div className="xs:hidden md:block w-full"></div>
          <div className="w-full">
            <div className="text-lg font-semibold mb-6">
              <p className="">Register to explore Gepzo!</p>
            </div>
            <div className="form my-3">
              <RegisterForm />
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Register;
